export const DASH_PINNED_UNITS_GRID_CONFIG_ID = 'dash-pinned-units'

export const DASH_PINNED_UNITS_GRID_CONFIG = {
  id: DASH_PINNED_UNITS_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 4, h: 3, static: true },
    lg: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 4.5, h: 3, static: true },
    md: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 6, h: 3, static: true },
    sm: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 8, h: 3, static: true },
    xs: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 12, h: 1.75, static: true },
    xxs: { i: DASH_PINNED_UNITS_GRID_CONFIG_ID, x: 0, y: 0, w: 12, h: 1.75, static: true }
  }
}
